import React from 'react'

import { CoinStore } from '../stores/CoinStore'
import CoinPicker from './CoinPicker'

export default class TradeCalculator extends React.Component {
  state = {
   symbol: 'LTCBTC',
   showCoinPicker: false,
   entry: 0.0123,
   size: 500,
   makerFee: 0.15,
   takerFee: 0.25,
   increment: 0.00001,
   openFee: 0.15,
   closeFee: 0.15,
   openType: 'limit',
   closeType: 'limit',
   renderHelp: false,
   includeFee: true,
   decimals: 8,
  }

  componentDidMount() {
    // get price from coin store and set entry price
    let coin = CoinStore.currencies['BTC_LTC']
    if (coin) {
      this.setState({entry: coin.lowestAsk})
    }
  }

  setFromEvent = (key, e) => {
    let obj = {}
    obj[key] = e.target.value
    
    if (key === 'makerFee') {
      if (this.state.openType === 'limit') {
        // update open fee to be the same as maker fee
        obj['openFee'] = obj[key]
      }
      if (this.state.closeType === 'limit') {
        // update close fee to be the same as maker fee
        obj['closeFee'] = obj[key]
      }
    } else if (key === 'takerFee') {
      if (this.state.openType === 'market') {
        // update open fee to be the same as taker fee
        obj['openFee'] = obj[key]
      }
      if (this.state.closeType === 'market') {
        // update close fee to be the same as taker fee
        obj['closeFee'] = obj[key]
      }
    }

    this.setState(obj)
  }

  setCloseType = (e) => {
    if (e.target.value === "market") {
      this.setState({closeFee: this.state.takerFee, closeType: e.target.value})
    } else {
      this.setState({closeFee: this.state.makerFee, closeType: e.target.value})
    }
  }

  setOpenType = (e) => {
    if (e.target.value === "market") {
      this.setState({openFee: this.state.takerFee, openType: e.target.value})
    } else {
      this.setState({openFee: this.state.makerFee, openType: e.target.value})
    }
  }

  setFeeInclusion = (e) => {
    if (e.target.value === "include") {
      this.setState({includeFee: true})
    } else {
      this.setState({includeFee: false})
    }
  }

  editor = () => {
    const {symbol, entry, size, makerFee, takerFee, increment, openType, closeType, includeFee} = this.state

    return (
      <div className='calculator fl w-20 mt2 pt2 pb2 pr2 ba b--moon-gray'>
        <div className='f5 pa2'>Long Position Calculator</div>
        <div className='fl w-100 pa2 pb0'>
          Symbol: 
          <input value={symbol} onChange={e => this.setFromEvent('symbol', e)}
            onFocus={() => this.setState({showCoinPicker: true})}
            className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
        </div>
        <div className='fl w-100 pa2 pb0'>
          Entry: 
          <input value={entry} onChange={e => this.setFromEvent('entry', e)}
            className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
        </div>
        <div className='fl w-100 pa2 pb0'>
          <div className='fl w-100'>
            Size: 
          </div>
          <input value={size} onChange={e => this.setFromEvent('size', e)}
            className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
        </div>
        <div className='fl w-100 pa2 pb0'>
          <div className='fl w-100'>
            Make fee: 
          </div>
          <div className='fl w-50'>
            <input value={makerFee} onChange={e => this.setFromEvent('makerFee', e)}
              className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
          </div>
          <div className='fl w-20 pa2 mb2'>%</div>
        </div>
        <div className='fl w-100 pa2 pb0'>
          <div className='fl w-100'>
            Taker fee: 
          </div>
          <div className='fl w-50'>
            <input value={takerFee} onChange={e => this.setFromEvent('takerFee', e)}
              className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
          </div>
          <div className='fl w-20 pa2 mb2'>%</div>
        </div>
        <div className='fl w-100 pa2 pb2'>
          <div className='fl w-100'>
            Open position: 
          </div>
          <div className='fl w-100'>
            <label className='mr3'>
              <input type="radio" name="openType" value="market" checked={openType === 'market'} onChange={this.setOpenType} />
              {' Market'}
            </label>
            <label>
              <input type="radio" name="openType" value="limit" checked={openType === 'limit'} onChange={this.setOpenType} />
              {' Limit'}
            </label>
          </div>
        </div>
        <div className='fl w-100 pa2 pb2'>
          <div className='fl w-100'>
            Close position: 
          </div>
          <div className='fl w-100'>
            <label className='mr3'>
              <input type="radio" name="closeType" value="market" checked={closeType === 'market'} onChange={this.setCloseType} />
              {' Market'}
            </label>
            <label>
              <input type="radio" name="closeType" value="limit" checked={closeType === 'limit'} onChange={this.setCloseType} />
              {' Limit'}
            </label>
          </div>
        </div>
        <div className='fl w-100 pa2 pb2'>
          <div className='fl w-100'>
            Total includes fee: 
          </div>
          <div className='fl w-100'>
            <label className='mr3'>
              <input type="radio" name="feeInclusionType" value="include" checked={includeFee} onChange={this.setFeeInclusion} />
              {' Include'}
            </label>
            <label>
              <input type="radio" name="feeInclusionType" value="exclude" checked={!includeFee} onChange={this.setFeeInclusion} />
              {' Exclude'}
            </label>
          </div>
        </div>
        <div className='fl w-100 pa2 pb0'>
          Table increment: 
          <input value={increment} onChange={e => this.setFromEvent('increment', e)}
            className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" />
        </div>
        <div className='fl w-100 pa2 pb2'>
          <small><a style={{cursor: 'pointer'}} onClick={() => this.setState({renderHelp: true})}>Help</a></small>
        </div>
      </div>
    )
  }

  calculateBuyCost(entry, size, fee, includeFee) {
    if (includeFee) {
      return entry * size
    } else {
      return size * (1 + fee/100) * entry
    }
  }

  calculateSellGains(entry, exit, size, openFee, closeFee, includeFee) {
    if (includeFee) {
      const actualSize = size * (1 - openFee/100)
      return actualSize * (1 - closeFee/100) * exit
    } else {
      return size * (1 - closeFee/100) * exit
    }
  }

  calculateBreakevenPrice(entry, size, openFee, closeFee, includeFee) {
    let price = 0
    if (includeFee) {
      price = entry / ( (1 - openFee/100) * (1 - closeFee/100) )
    } else {
      price = entry * ( (1 + openFee/100) / (1 - closeFee/100) )
    }
    // round to 8 decimal places then make sure sell > buy
    // if it is not, increase by 1 satoshi and return that (FIXME: this is probably wrong)
    price = parseFloat(price.toFixed(8))
    const sellGains = this.calculateSellGains(entry, price, size, openFee, closeFee, includeFee)
    const buyCost = this.calculateBuyCost(entry, size, openFee, includeFee)
    if (sellGains < buyCost) price += 0.00000001
    return price
  }

  ladders() {
    const {entry, size, openFee, closeFee, increment, includeFee, decimals} = this.state

    const buyCost = Number(this.calculateBuyCost(entry, size, openFee, includeFee).toFixed(8))
    
    const breakevenPrice = Number(this.calculateBreakevenPrice(entry, size, openFee, closeFee, includeFee).toFixed(8))

    const steps = 50

    // Calculate possible profits for each price increment
    let profits = []
    for (let i = 0; i <= steps; i++) {
      const exit = Number((breakevenPrice + i * increment).toFixed(8))
      const sellGains = this.calculateSellGains(entry, exit, size, openFee, closeFee, includeFee)
      const profit = sellGains - buyCost
      const priceDiff = exit - entry
      const profitPrct = (sellGains - buyCost) / buyCost * 100
      profits.push({ exit, sellGains, priceDiff, profit, profitPrct })
    }

    // Calculate possible losses for each price increment
    let losses = []
    for (let i = 0; i <= steps; i++) {
      const exit = Number((breakevenPrice - i * increment).toFixed(8))
      const sellGains = this.calculateSellGains(entry, exit, size, openFee, closeFee, includeFee)
      const profit = sellGains - buyCost
      const priceDiff = exit - entry
      const profitPrct = (sellGains - buyCost) / buyCost * 100
      losses.push({ exit, sellGains, priceDiff, profit, profitPrct })
    }

    return (
      <div className='fl'>
        <div className='w-100 mb2 pa2 ba b--moon-gray tc'>
          <span className='pa2'>Breakeven Price: {breakevenPrice.toFixed(decimals)}</span>
          <span className='pa2'>Buy Total: {buyCost.toFixed(decimals)}</span>
          <span className='fr'>
            <label htmlFor="decimals">{'Decimals '}</label>
            <select name="decimals" id="decimals"
              onChange={(e) => this.setFromEvent('decimals', e)}
              value={this.state.decimals}
            >
              <option value="2">2</option>
              <option value="4">4</option>
              <option value="6">6</option>
              <option value="8">8</option>
            </select>
          </span>
        </div>
        <table className='dib mr2 trade-calc'>
          <thead>
            <tr>
              <th className="f4" colSpan="5">Profit</th>
            </tr>
            <tr>
              <th>Sell @</th>
              <th>Price Diff.</th>
              <th>Profit</th>
              <th>Profit %</th>
              <th>Sell Total</th>
            </tr>
          </thead>
          <tbody>
            {profits.map(({exit, sellGains, priceDiff, profit, profitPrct}, idx) => (
              <tr key={idx} className='ffw'>
                <td>{exit.toFixed(decimals)}</td>
                <td>{priceDiff.toFixed(decimals)}</td>
                <td>{profit.toFixed(decimals)}</td>
                <td className='prct'>{profitPrct.toFixed(3)}</td>
                <td>{sellGains.toFixed(decimals)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <table className='dib trade-calc'>
          <thead>
            <tr>
              <th className="f4" colSpan="5">Loss</th>
            </tr>
            <tr>
              <th>Sell @</th>
              <th>Price Diff.</th>
              <th>Loss</th>
              <th>Loss %</th>
              <th>Sell Total</th>
            </tr>
          </thead>
          <tbody>
            {losses.map(({exit, sellGains, priceDiff, profit, profitPrct}, idx) => (
              <tr key={idx} className='ffw'>
                <td>{exit.toFixed(decimals)}</td>
                <td>{priceDiff.toFixed(decimals)}</td>
                <td>{profit.toFixed(decimals)}</td>
                <td className='prct'>{profitPrct.toFixed(3)}</td>
                <td>{sellGains.toFixed(decimals)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  prettify(symbol) {
    const [a, b] = symbol.split('_')
    return b + a
  }

  onCoinPick = (symbol) => {
    let state = {showCoinPicker: false, symbol: this.prettify(symbol)}

    // get price from coin store and set entry price
    let coin = CoinStore.currencies[symbol]
    if (coin) {
      state['entry'] = coin.lowestAsk
    }

    this.setState(state)
  }

  render() {
    return (
      <div className='pa2'>
        <nav className="w-100">
          <div className="overflow-x-auto">
            <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr3'
              href="#charts"
              onClick={this.props.onCancel}>Charts</a>
          </div>
        </nav>

        {this.state.showCoinPicker &&
          <CoinPicker
            onCancel={() => this.setState({showCoinPicker: false})}
            onCoinSelect={this.onCoinPick}
          />
        }

        { this.renderHelp() }

        { this.editor() }

        <div className='h-75 overflow-y-auto mt2 pl2'>
          { this.ladders() }
        </div>
      </div>
    )
  }

  renderHelp = () => {
    if (this.state.renderHelp) {
      return (
        <div className='absolute calc-help z-index-100 shadow-2'>
          <div className='w-100'>
            <button className='bg-animate'
              onClick={() => this.setState({renderHelp: false})}>Close</button>
          </div>
          <div className='w-100 pa3'>
            This tool will help traders calculate profits/losses on long positions. 
            By specifying your maker and taker fees, the size and the entry price of your position, 
            the calculator outputs a Breakeven Price (the price to close the position without profit/loss after paying fees) 
            and tables displaying potential profit/loss when closing the position at the given price.
            <br/>
            <a href="longCalc.png" target="_blank" rel="noopener noreferrer">See equations.</a>
          </div>
        </div>
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/TradeCalculator.js